// /business/success — post-Stripe-checkout landing page
import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { BadgeCheck, ArrowRight } from 'lucide-react';
import { useQueryClient } from '@tanstack/react-query';

export default function BusinessSuccess() {
  const [params] = useSearchParams();
  const placeId = params.get('place_id');
  const qc = useQueryClient();

  useEffect(() => {
    // Invalidate so dashboard and place detail refetch with new verified status
    qc.invalidateQueries({ queryKey: ['business-owned'] });
    qc.invalidateQueries({ queryKey: ['place', placeId] });
  }, [placeId, qc]);

  return (
    <div className="max-w-md mx-auto px-4 py-20 text-center">
      <div className="w-16 h-16 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center mx-auto mb-5">
        <BadgeCheck className="w-8 h-8 text-green-600 dark:text-green-400" />
      </div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">You're verified!</h1>
      <p className="text-gray-500 dark:text-gray-400 text-sm mb-8">
        Your business now shows the Verified badge on KoreanHub. Korean expats will see your
        listing at the top of search results.
      </p>
      <div className="flex flex-col gap-3">
        {placeId && (
          <Link
            to={`/places/${placeId}`}
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-[#C8102E] text-white font-medium hover:bg-[#A00D25] transition-colors"
          >
            View your listing <ArrowRight className="w-4 h-4" />
          </Link>
        )}
        <Link
          to="/business/dashboard"
          className="inline-flex items-center justify-center px-5 py-3 rounded-xl border border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300 text-sm hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
        >
          Go to dashboard
        </Link>
      </div>
    </div>
  );
}
